import type { AiGenerate, AiGenerateResult } from '@erp/shared';

import { api } from './api.js';

/**
 * Staff AI content generation — POST /api/v1/ai/generate (single-shot).
 * Used by the item form (description), CMS product page (SEO), and the
 * TranslationEditor (translate). Gated server-side by the `ai` module + ai.use.
 */
export async function aiGenerate(input: AiGenerate): Promise<AiGenerateResult> {
  return (await api().post<AiGenerateResult>('/ai/generate', input)).data;
}
